import React, { ReactElement } from "react";
import { FiscaleAftrekData } from "../../../../../../.generated/rapportage/rapportagetypes";
import { Column } from "../../../../components/BaseTable";
import Table from "../../../../components/Table";

export type FiscaleAftrekTransformed = {
  onderdeel: string;
  typeFinanciering: string | null;
  ingangsdatum: string | null;
  aankoopprijs: number | null;
  benodigdeFinanciering: number | null;
  hoogteHypotheek: number | null;
  hoogteOverbruggingskriet: number | null;
  kapitaalOpbouw: number | null;
  fiscaalAftrekbaar: number | null;
  verkoopprijs: number | null;
  gedeelteBox3: number | null;
  EigenWoningReserveBijVerkoop: number | null;
};

export const FiscaleAftrekTable = ({
  data,
}: {
  data: FiscaleAftrekData;
}): ReactElement => {
  const columns: Column[] = [
    {
      header: " ",
      accessor: "onderdeel",
    },
    {
      header: "Type financiering",
      accessor: "typeFinanciering",
    },
    {
      header: "Ingangsdatum",
      accessor: "ingangsdatum",
      dataType: "date",
    },
    {
      header: "Aankoopprijs",
      accessor: "aankoopprijs",
      dataType: "currency",
    },
    {
      header: "Benodigde financiering",
      accessor: "benodigdeFinanciering",
      dataType: "currency",
    },
    {
      header: "Hoogte hypotheek",
      accessor: "hoogteHypotheek",
      dataType: "currency",
    },
    {
      header: "Hoogte overbruggingskrediet",
      accessor: "hoogteOverbruggingskriet",
      dataType: "currency",
    },
    {
      header: "Kapitaalopbouw",
      accessor: "kapitaalOpbouw",
      dataType: "currency",
    },
    {
      header: "Fiscaal aftrekbaar",
      accessor: "fiscaalAftrekbaar",
      dataType: "currency",
    },
    {
      header: "Verkoopprijs",
      accessor: "verkoopprijs",
      dataType: "currency",
    },
    {
      header: "Gedeelte box 3",
      accessor: "gedeelteBox3",
      dataType: "currency",
    },
    {
      header: "Eigen woningreserve bij verkoop",
      accessor: "EigenWoningReserveBijVerkoop",
      dataType: "currency",
    },
  ];

  const dataTransformed: FiscaleAftrekTransformed[] = [
    {
      onderdeel: "Huidige situatie",
      typeFinanciering: null,
      ingangsdatum: data.ingangsdatumHuidig,
      aankoopprijs: null,
      benodigdeFinanciering: null,
      hoogteHypotheek: data.hoogteHypotheekHuidig,
      hoogteOverbruggingskriet: null,
      kapitaalOpbouw: data.kapitaalopbouwHuidig,
      fiscaalAftrekbaar: data.fiscaalAftrekbaarHuidig,
      verkoopprijs: data.verkoopprijsHuidig,
      gedeelteBox3: data.gedeelteInBox3Huidig,
      EigenWoningReserveBijVerkoop: null,
    },
    {
      onderdeel: "Nieuwe situatie",
      typeFinanciering: data.typeFinanciering,
      ingangsdatum: data.ingangsdatumVoorstel,
      aankoopprijs: data.aankoopprijsVoorstel,
      benodigdeFinanciering: data.benodigdeFinancieringVoorstel,
      hoogteHypotheek: data.hoogteHypotheekVoorstel,
      hoogteOverbruggingskriet: data.hoogteOverbruggingskredietVoorstel,
      kapitaalOpbouw: data.kapitaalopbouwVoorstel,
      fiscaalAftrekbaar: data.fiscaalAftrekbaarVoorstel,
      verkoopprijs: null,
      gedeelteBox3: data.gedeelteInBox3Voorstel,
      EigenWoningReserveBijVerkoop: data.eigenWoningReserveBijVerkoopVoorstel,
    },
  ];

  return (
    <Table
      data={dataTransformed}
      columns={columns}
      rotate={true}
      id="fiscale-aftrek-table"
    />
  );
};
